import React from 'react';
import Avatar from '@mui/material/Avatar';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    root: {
        width: 110,
        height: 110,
        margin: 'auto',
        borderRadius: '0px 0px 75px 70px',
        '& img':{
            width: '80%',
            height: '80%',
        },
        '@media (max-width:1024px)':{
            width: 100,
            height: 100,
        },
        '@media (max-width:768px)':{
            width: 78,
            height: 82,
        },
    },
}));

export default function ElementoDeIcono(props) {
    const classes = useStyles(props);
    return(<Avatar className={classes.root} alt="Logo TSE" src={"/assets/tseIcono.svg"} />)
}
